(() => {
  if (window.btComplementaryBundleInitialized) return;
  window.btComplementaryBundleInitialized = true;

  const getProductInfo = (element) => element.closest('product-info');
  const getItems = (productInfo) => [...productInfo.querySelectorAll('[data-bt-complementary-item]')];
  const getQuantity = (item) => Number(item.querySelector('[data-bt-quantity]')?.textContent || 0);

  const formatMoney = (cents) => {
    if (window.FoxTheme?.Currency?.formatMoney) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings?.moneyFormat);
    }

    const currency = window.Shopify?.currency?.active || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency,
    }).format(cents / 100);
  };

  const getVariantPrices = (productInfo) => {
    try {
      return JSON.parse(productInfo.dataset.btVariantPrices || '[]');
    } catch (_error) {
      return [];
    }
  };

  const getCurrentVariantPrice = (productInfo) => {
    const variantId = productInfo.querySelector('form[is="product-form"] [name="id"]')?.value;
    return getVariantPrices(productInfo).find((variant) => String(variant.id) === String(variantId));
  };

  const updateBundlePrice = (productInfo) => {
    const sectionId = productInfo.dataset.section;
    const priceContainer = productInfo.querySelector(`#price-${CSS.escape(sectionId)}`);
    if (!priceContainer) return;

    const variant = getCurrentVariantPrice(productInfo);
    if (!variant) return;

    const items = getItems(productInfo);
    const accessoryTotal = items.reduce((sum, item) => sum + getQuantity(item) * Number(item.dataset.price || 0), 0);
    const hasAccessories = items.some((item) => getQuantity(item) > 0);
    const grossifyPrice = productInfo.dataset.btGrossifyPrice === 'true';
    const basePrice = grossifyPrice ? Math.round(Number(variant.price) * 1.19) : Number(variant.price);
    const baseCompareAt = grossifyPrice
      ? Math.round(Number(variant.compareAt || variant.price) * 1.19)
      : Number(variant.compareAt || variant.price);
    const totalPrice = basePrice + accessoryTotal;

    const regularPrice = priceContainer.querySelector('.f-price__regular .f-price-item--regular');
    const salePrice = priceContainer.querySelector('.f-price__sale .f-price-item--sale');
    const comparePrice = priceContainer.querySelector('.f-price__sale .f-price-item--regular s');
    const priceText = formatMoney(hasAccessories ? totalPrice : basePrice);

    if (regularPrice && regularPrice.textContent !== priceText) regularPrice.textContent = priceText;
    if (salePrice && salePrice.textContent !== priceText) salePrice.textContent = priceText;
    if (comparePrice) {
      const compareText = formatMoney(hasAccessories ? baseCompareAt + accessoryTotal : baseCompareAt);
      if (comparePrice.textContent !== compareText) comparePrice.textContent = compareText;
    }
  };

  const refreshPriceSoon = (productInfo) => {
    requestAnimationFrame(() => updateBundlePrice(productInfo));
    setTimeout(() => updateBundlePrice(productInfo), 80);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bt-quantity-plus], [data-bt-quantity-minus]');
    if (!button) return;

    const productInfo = getProductInfo(button);
    const item = button.closest('[data-bt-complementary-item]');
    const output = item?.querySelector('[data-bt-quantity]');
    if (!productInfo || !item || !output || item.dataset.available !== 'true') return;

    const nextQuantity = Math.max(0, getQuantity(item) + (button.hasAttribute('data-bt-quantity-plus') ? 1 : -1));
    output.textContent = String(nextQuantity);
    item.classList.toggle('is-selected', nextQuantity > 0);
    refreshPriceSoon(productInfo);
  });

  document.addEventListener('change', (event) => {
    const productInfo = event.target.closest('product-info');
    if (productInfo?.matches('[data-bt-variant-prices]')) refreshPriceSoon(productInfo);
  });

  document.querySelectorAll('product-info[data-bt-variant-prices]').forEach((productInfo) => {
    const priceContainer = productInfo.querySelector(`#price-${CSS.escape(productInfo.dataset.section)}`);
    if (priceContainer) {
      new MutationObserver(() => refreshPriceSoon(productInfo)).observe(priceContainer, { childList: true, subtree: true });
    }
  });
})();
